import grouping from '../../../constants/grouping/final-supplementary.json';
import InputsSection from "../../../components/common/InputsSection/InputsSection";

const FinalSupplemntary = () => {
    return (
        <div>
            <div className='d-flex flex-row flex-wrap'>
                {grouping.main?.sections?.map((section, index) => (
                    // Split sections with index to be separated into the columns using indices
                    <div style={{
                        width: section.fullWidth ? '100%' : '50%',
                    }}>
                        <div style={{ marginLeft: 8, marginRight: 8 }}>
                            <InputsSection
                                key={index}
                                page='main'
                                {...section}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
};

export default FinalSupplemntary;